import { createLogger } from '@superbet-group/web.lib.vue-utilities';

import { commonConfig as config } from '@src/config/common';
import { shellLocalConfig } from '@src/config/shell/localConfig';

export const featureLogger = createLogger({
    dsn: shellLocalConfig.sseSentryDsn,
    sampleRate: 0.01,
    environment: config.environment.name,
    version: config.environment.version,
    isProduction: config.environment.isProduction,
    isTest: config.environment.isTest,
    maxValueLength: 3000,
});
